<div class="pageheader">
    <div class="page-title">
        <h1>Distribution Search</h1>
    </div>
</div>
<!--document filter-->
<div class="container container-fixed">
    <div class="row">
        <div class="col-sm-6 col-md-3">
            <ep-distribution-object-selector #distributionObjectSelector (selectedDistributionObjectChange)="distributionObjectChanged($event)" (selectedDistributionObjectGroupChange)="distributionObjectGroupChanged($event)"></ep-distribution-object-selector>
        </div>
    </div>

    <!--Partner filter-->
    <br class="xs-20"/>
    <div class="row">
        <div class="form-group col-sm-6 col-md-5 justifyer">
            <h2 class="justify-item">From Partner/To Partner</h2>
            <div class="justify-item control control-checkbox   control-right">
                <label>
                    Split from and to<input type="checkbox"  [(ngModel)]="searchObject.splitFromAndTo" (change)="splitFromAndToChange($event)" ><i></i>
                </label>
            </div>
        </div>
    </div>
    <div class="row">
        <div class="col-sm-6 col-md-5">
            <div class="form-group">
                <label [title]="searchObject.splitFromAndTo ? 'Search by a specific from partner': 'Search by a specific from/to partner'">Partner</label>
                <ep-partner-selector #partnerSelectorFrom (selectedPartnerIdChange)="searchObject.partnerFromId = $event"></ep-partner-selector>
            </div>
            <ep-document-config-selector-simple #docConfigInSimple [direction]="searchObject.splitFromAndTo ? 'In' : null" [titleText]="searchObject.splitFromAndTo ? 'Search by a specific ingoing format/variant version' :'Search by a specific in- or outgoing format/variant version'" (documentConfigChange)="searchObject.formatFromId = $event?.Format?.FormatsId; searchObject.variantFromId = $event?.Variant?.VariantsId; searchObject.versionFromId = $event?.VariantVersion?.VariantVersionsId; searchObject.documentConfigIdFrom = $event?.DocumentConfigsId"></ep-document-config-selector-simple>

        </div>
        <div class="col-sm-6 col-md-5" [hidden]="!searchObject.splitFromAndTo">
            <div class="form-group">
                <label title="Search by a specific to partner">Partner</label>
                <ep-partner-selector #partnerSelectorTo (selectedPartnerIdChange)="searchObject.partnerToId = $event"></ep-partner-selector>
            </div>
            <div class="form-group">
                <ep-document-config-selector-simple #docConfigOutSimple direction="Out" [titleText]="'Search by a specific outgoing format/variant version'"  (documentConfigChange)="searchObject.formatToId = $event?.Format?.FormatsId; searchObject.variantToId = $event?.Variant?.VariantsId; searchObject.versionToId = $event?.VariantVersion?.VariantVersionsId; searchObject.documentConfigIdTo = $event?.DocumentConfigsId"></ep-document-config-selector-simple>
            </div>
        </div>
    </div>

    <div class="row">
        <div class="col-sm-6 col-md-5">
            <div class="form-group control control-checkbox">
                <label>
                    Include last activity<input type="checkbox"  [(ngModel)]="searchObject.includeLatestDocumentDate"><i></i>
                </label>
            </div>
            <div class="form-group control control-checkbox">
                <label>
                    Include lastest alert status<input type="checkbox"  [(ngModel)]="searchObject.includeLatestAlertStatus"><i></i>
                </label>
            </div>
        </div>
    </div>

    <div class="row">
        <div class="col-sm-12">
            <button class="btn btn-primary" type="button" (click)="search()" id="searchButton">Search</button>
            <button class="btn btn-link" type="button" (click)="reset()" id="clearButton">Reset search <ep-svg-icon icon="circle-cross"></ep-svg-icon></button>
        </div>
    </div>
</div>
